<div class="d-flex flex-column gap-2 ms-n1">
    @for (roleLocation of roleTeamLocations; track roleLocation.roleLocationId) {
        <adapt-link-team [teamId]="roleLocation.teamId"
                         [showIcon]="true"></adapt-link-team>
    } @empty {
       <p>No teams are currently allocated to this role.</p>
    }
</div>
